var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":"Provincia","items":_vm.provincias,"value":_vm.value,"multiple":_vm.multiple,"hide-details":"","chips":_vm.chips,"item-value":"id","item-text":"desig"},on:{"input":function($event){_vm.actualizaValor($event)}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430f564e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ProvinciaSelect.vue
// module id = DlkL
// module chunks = 0